import { render, staticRenderFns } from "./vehicle-brands.vue?vue&type=template&id=07afa16a&scoped=true&"
import script from "./vehicle-brands.vue?vue&type=script&lang=js&"
export * from "./vehicle-brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afa16a",
  null
  
)

export default component.exports